/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HistoryModificationDetailDto } from './HistoryModificationDetailDto';
import {
    HistoryModificationDetailDtoFromJSON,
    HistoryModificationDetailDtoFromJSONTyped,
    HistoryModificationDetailDtoToJSON,
    HistoryModificationDetailDtoToJSONTyped,
} from './HistoryModificationDetailDto';
import type { ActivityMessageSegmentDto } from './ActivityMessageSegmentDto';
import {
    ActivityMessageSegmentDtoFromJSON,
    ActivityMessageSegmentDtoFromJSONTyped,
    ActivityMessageSegmentDtoToJSON,
    ActivityMessageSegmentDtoToJSONTyped,
} from './ActivityMessageSegmentDto';
import type { EntityTypeEnum } from './EntityTypeEnum';
import {
    EntityTypeEnumFromJSON,
    EntityTypeEnumFromJSONTyped,
    EntityTypeEnumToJSON,
    EntityTypeEnumToJSONTyped,
} from './EntityTypeEnum';
import type { HistoryPriorityEnum } from './HistoryPriorityEnum';
import {
    HistoryPriorityEnumFromJSON,
    HistoryPriorityEnumFromJSONTyped,
    HistoryPriorityEnumToJSON,
    HistoryPriorityEnumToJSONTyped,
} from './HistoryPriorityEnum';
import type { ActivityFeedEntityLinkDto } from './ActivityFeedEntityLinkDto';
import {
    ActivityFeedEntityLinkDtoFromJSON,
    ActivityFeedEntityLinkDtoFromJSONTyped,
    ActivityFeedEntityLinkDtoToJSON,
    ActivityFeedEntityLinkDtoToJSONTyped,
} from './ActivityFeedEntityLinkDto';

/**
 * Represents a group of related history events (used for Standard granularity level).
 * Events are grouped by entity type and time window (59 minutes).
 * Major events are displayed individually (isMajor=true) while minor events are grouped.
 * 
 * @export
 * @interface HistoryEventGroupDto
 */
export interface HistoryEventGroupDto {
    /**
     * ID of the first event in the group
     * @type {string}
     * @memberof HistoryEventGroupDto
     */
    id: string;
    /**
     * Summary title of the group (e.g., "Updates to tenant Jean Dupont")
     * @type {string}
     * @memberof HistoryEventGroupDto
     */
    title: string;
    /**
     * Summary message (e.g., "3 modifications made")
     * @type {string}
     * @memberof HistoryEventGroupDto
     */
    message: string;
    /**
     * 
     * @type {HistoryPriorityEnum}
     * @memberof HistoryEventGroupDto
     */
    priority: HistoryPriorityEnum;
    /**
     * Timestamp of the first event in the group
     * @type {Date}
     * @memberof HistoryEventGroupDto
     */
    createdAt: Date;
    /**
     * Timestamp of the last event in the group
     * @type {Date}
     * @memberof HistoryEventGroupDto
     */
    lastModifiedAt: Date;
    /**
     * 
     * @type {EntityTypeEnum}
     * @memberof HistoryEventGroupDto
     */
    entityType?: EntityTypeEnum;
    /**
     * ID of the entity concerned
     * @type {string}
     * @memberof HistoryEventGroupDto
     */
    entityId?: string | null;
    /**
     * Display label of the entity (tenant name, property address, etc.)
     * @type {string}
     * @memberof HistoryEventGroupDto
     */
    entityLabel?: string | null;
    /**
     * Number of events in the group
     * @type {number}
     * @memberof HistoryEventGroupDto
     */
    count: number;
    /**
     * True if this is a major event (not grouped), false otherwise
     * @type {boolean}
     * @memberof HistoryEventGroupDto
     */
    isMajor: boolean;
    /**
     * Details of modifications (displayed on hover/expansion)
     * @type {Array<HistoryModificationDetailDto>}
     * @memberof HistoryEventGroupDto
     */
    details: Array<HistoryModificationDetailDto>;
    /**
     * List of entity links referenced in the message
     * @type {Array<ActivityFeedEntityLinkDto>}
     * @memberof HistoryEventGroupDto
     */
    entities?: Array<ActivityFeedEntityLinkDto>;
    /**
     * Whether the event group is new/unread
     * @type {boolean}
     * @memberof HistoryEventGroupDto
     */
    isNew?: boolean;
    /**
     * Key of the Lucide React icon to display for this group.
     * Must match a valid Lucide icon name in PascalCase (e.g., "FileText", "User", "CheckCircle").
     * See https://lucide.dev/icons for available icons.
     * 
     * @type {string}
     * @memberof HistoryEventGroupDto
     */
    iconKey?: string;
    /**
     * Message riche (rendre a la place de message quand present)
     * @type {Array<ActivityMessageSegmentDto>}
     * @memberof HistoryEventGroupDto
     */
    segments?: Array<ActivityMessageSegmentDto> | null;
    /**
     * Code stable pour icone/couleur/filtre : simulation | client | risque | devis | contrat | paiement | document | note | autre
     * 
     * @type {string}
     * @memberof HistoryEventGroupDto
     */
    category?: string | null;
    /**
     * Libelle pret a afficher (Simulation, Client, Risque...)
     * @type {string}
     * @memberof HistoryEventGroupDto
     */
    categoryLabel?: string | null;
}



/**
 * Check if a given object implements the HistoryEventGroupDto interface.
 */
export function instanceOfHistoryEventGroupDto(value: object): value is HistoryEventGroupDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('isMajor' in value) || value['isMajor'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function HistoryEventGroupDtoFromJSON(json: any): HistoryEventGroupDto {
    return HistoryEventGroupDtoFromJSONTyped(json, false);
}

export function HistoryEventGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryEventGroupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'message': json['message'],
        'priority': HistoryPriorityEnumFromJSON(json['priority']),
        'createdAt': (new Date(json['createdAt'])),
        'lastModifiedAt': (new Date(json['lastModifiedAt'])),
        'entityType': json['entityType'] == null ? undefined : EntityTypeEnumFromJSON(json['entityType']),
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'entityLabel': json['entityLabel'] == null ? undefined : json['entityLabel'],
        'count': json['count'],
        'isMajor': json['isMajor'],
        'details': ((json['details'] as Array<any>).map(HistoryModificationDetailDtoFromJSON)),
        'entities': json['entities'] == null ? undefined : ((json['entities'] as Array<any>).map(ActivityFeedEntityLinkDtoFromJSON)),
        'isNew': json['isNew'] == null ? undefined : json['isNew'],
        'iconKey': json['iconKey'] == null ? undefined : json['iconKey'],
        'segments': json['segments'] == null ? undefined : ((json['segments'] as Array<any>).map(ActivityMessageSegmentDtoFromJSON)),
        'category': json['category'] == null ? undefined : json['category'],
        'categoryLabel': json['categoryLabel'] == null ? undefined : json['categoryLabel'],
    };
}

export function HistoryEventGroupDtoToJSON(json: any): HistoryEventGroupDto {
    return HistoryEventGroupDtoToJSONTyped(json, false);
}

export function HistoryEventGroupDtoToJSONTyped(value?: HistoryEventGroupDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'message': value['message'],
        'priority': HistoryPriorityEnumToJSON(value['priority']),
        'createdAt': ((value['createdAt']).toISOString()),
        'lastModifiedAt': ((value['lastModifiedAt']).toISOString()),
        'entityType': EntityTypeEnumToJSON(value['entityType']),
        'entityId': value['entityId'],
        'entityLabel': value['entityLabel'],
        'count': value['count'],
        'isMajor': value['isMajor'],
        'details': ((value['details'] as Array<any>).map(HistoryModificationDetailDtoToJSON)),
        'entities': value['entities'] == null ? undefined : ((value['entities'] as Array<any>).map(ActivityFeedEntityLinkDtoToJSON)),
        'isNew': value['isNew'],
        'iconKey': value['iconKey'],
        'segments': value['segments'] == null ? undefined : ((value['segments'] as Array<any>).map(ActivityMessageSegmentDtoToJSON)),
        'category': value['category'],
        'categoryLabel': value['categoryLabel'],
    };
}

